import "./polyfills";
import React from "react";
import { createRoot } from 'react-dom/client';

import * as serviceWorker from "./serviceWorker";

import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./DemoPages/Main";
import { AuthProvider } from "./auth/AuthContext";
import { ThemeProvider } from "./theme/ThemeProvider";
import { NotificationProvider } from "./contexts/NotificationContext";
import configureAppStore from "./config/configureStore";
import { Provider } from "react-redux";
import RouteOverlaySpinner from "./components/RouteOverlaySpinner";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const store = configureAppStore();
const rootElement = document.getElementById("root");

const renderApp = (Component) => (
  <Provider store={store}>
    <ThemeProvider>
      <AuthProvider>
        <NotificationProvider>
        <HashRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Component />
        <RouteOverlaySpinner />
        <ToastContainer 
          position="top-right" 
          autoClose={2000} 
          newestOnTop 
          closeOnClick 
          pauseOnHover 
          hideProgressBar={true}
        />
      </HashRouter>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  </Provider>
);

const root = createRoot(rootElement);
root.render(renderApp(Main));

if (module.hot) {
  module.hot.accept("./DemoPages/Main", () => {
    const NextApp = require("./DemoPages/Main").default;
    root.render(renderApp(NextApp));
  });
}
serviceWorker.unregister();